module.exports = __webpack_public_path__ + "img/公司简介.f505e68c.png";